import { render, staticRenderFns } from "./AdminDomains.vue?vue&type=template&id=e2c18c1e&scoped=true"
import script from "./AdminDomains.vue?vue&type=script&lang=ts"
export * from "./AdminDomains.vue?vue&type=script&lang=ts"
import style0 from "./AdminDomains.vue?vue&type=style&index=0&id=e2c18c1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c18c1e",
  null
  
)

export default component.exports